<template>
  <SubscriptionModalForm
    :modal="modal"
    :successModalData="successModalData"
    :show="showModal"
    @handleModal="handleSubscriptionModal"
  />
</template>

<script setup>
import SubscriptionModalForm from './SubscriptionModalForm.vue';
import {onMounted, ref} from 'vue';
import {getCookie} from "@/utils/utils";

const props = defineProps({
  blogDetails: {
    title: String,
    date: String,
    content: HTMLElement,
    pagination: {
      previous: {
        title: String,
        link: String,
      },
      backToList: {
        title: String,
        link: String,
      },
      next: {
        title: String,
        link: String,
      },
    },
    categories: {
      title: String,
      children: Array,
    },
    recentBlogs: {
      title: String,
      children: Array,
    },
  },
  modal: Object,
  successModalData: Object
});

let showModal = ref(false)

const handleSubscriptionModal = () => showModal.value = !showModal.value

onMounted(() => setTimeout(() => {
  if (!getCookie('subscription')) {
    showModal.value = true;
  }
}, 10000))
</script>
